/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

function VideoDeliveryItemEditViewAudioChannelMappingController(this: JS5Object,
                                                                AudioChannelMappingService: JS5Object) {

    this.$onChanges = (changes: JS5Object) => {
        if (_.has(changes, 'editData')) {
            AudioChannelMappingService.setDeliveryItem(this.editData);
            this.videoChannelMapGroup = AudioChannelMappingService.getChannelMappingGroup('VIDEO', 0);
        }
    };

    this.$onInit = () => {
        AudioChannelMappingService.initialize(this.editData);
        this.videoChannelMapGroup = AudioChannelMappingService.getChannelMappingGroup('VIDEO', 0);
    }
}

angular.module('prism-ui.deliveryProfiles').component('videoDeliveryItemEditViewAudioChannelMapping', {
    templateUrl: 'system/partner/editor/components/view/deliveryProfiles/editor/components/deliveryItems/editor/deliveryItem/editor/components/audioChannelMapping/delivery-items-video-edit-view-audio-channel-mapping-template.html',
    controller: VideoDeliveryItemEditViewAudioChannelMappingController,
    bindings: {
        editData: '<',
        mediaAcceptProfiles: '<',
        languages: '<',
        roles: '<'
    }
});
